import { Icon, IIconProps, Size, Theme, Tooltip } from '@busybusy/webapp-react-ui';

export interface ITooltipIconProps extends IIconProps {
  tooltipLabel: string;
}

function TooltipIcon({ tooltipLabel, size = Size.MEDIUM, theme = Theme.DARK, ...iconProps }: ITooltipIconProps) {
  return (
    <Tooltip label={tooltipLabel}>
      <Icon size={size} theme={theme} {...iconProps} />
    </Tooltip>
  );
}

export default TooltipIcon;
